module.exports = __webpack_public_path__ + "img/card_shadow_top_right.8a370763.svg";